// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type CcStdFilledIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from cc-std-filled.svg
 */
export default function CcStdFilledIcon(props: CcStdFilledIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="CcStdFilledIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M7.985 0q3.357 0 5.715 2.343a7.7 7.7 0 0 1 1.714 2.579Q15.999 6.37 16 8a8.2 8.2 0 0 1-.578 3.078 7.35 7.35 0 0 1-1.708 2.536 8.2 8.2 0 0 1-2.657 1.772Q9.572 16 7.986 16a7.8 7.8 0 0 1-3.036-.607 8.05 8.05 0 0 1-2.6-1.757A7.846 7.846 0 0 1 0 8q0-1.586.607-3.05A8 8 0 0 1 2.371 2.33Q4.657 0 7.985 0m-2.2 5.515q-1.014 0-1.678.672-.665.67-.665 1.814 0 1.17.657 1.828t1.73.657q.671 0 1.228-.335.477-.288.776-.76l.095-.162-.985-.5q-.287.686-.986.686-.53 0-.8-.386Q4.884 8.643 4.884 8q0-1.415 1.072-1.415a.991.991 0 0 1 .814.509l.071.134 1.072-.557q-.643-1.157-2.129-1.157m2.95.672q.665-.672 1.679-.672 1.486 0 2.114 1.157l-1.057.557-.072-.134a1 1 0 0 0-.35-.366 1 1 0 0 0-.478-.143Q9.5 6.586 9.5 8.001q0 .642.272 1.028.27.386.8.386.7 0 .985-.686l1 .5-.115.189q-.306.453-.77.733a2.3 2.3 0 0 1-1.214.335q-1.086 0-1.735-.657-.65-.657-.65-1.828-.001-1.143.664-1.814"
        />
      </g>
    </svg>
  );
}
